import { Tooltip } from '@/components/primitives/Tooltip'

import { Row } from '../../Row'

import { useTexts } from '../useTexts'

interface Props {
  count: number
  onSelect: () => void
}

export function OrdersWithViolations(props: Props) {
  const { count, onSelect } = props
  const texts = useTexts()

  return (
    <Tooltip
      textAlign="left"
      placement="right"
      title={texts.violated}
      subtitle={texts.violatedTooltip}
    >
      <Row
        onClick={onSelect}
        text={texts.violated}
        value={count}
        disabled={count === 0}
        testId="plan-summary-orders-with-violations"
      />
    </Tooltip>
  )
}
